module.exports = __webpack_public_path__ + "static/lecturer_view.bab5ca40.svg";